import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router';
import navigationService from '../services/navigationService';

/**
 * Component that initializes the navigation service
 * Should be placed at the root of your app, inside Router
 * This allows us to use navigation without passing navigate everywhere
 */
const NavigationInitializer = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Initialize navigation service once
    navigationService.init(navigate, location);
  }, [navigate, location]);

  return children;
};

export default NavigationInitializer;
